import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e32e5b1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "investigator-investigations" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Investigations", -1))
const _hoisted_4 = { class: "search" }
const _hoisted_5 = { class: "search-inputs" }
const _hoisted_6 = { class: "search-bar" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search fa-lg" })
], -1))
const _hoisted_8 = { class: "checkbox-button" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Show active only")
], -1))
const _hoisted_10 = { class: "checkbox-button" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Cause driven only")
], -1))
const _hoisted_12 = { class: "checkbox-button" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Reply required")
], -1))
const _hoisted_14 = { class: "checkbox-button" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Show Training only")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", null, "  ", -1))
const _hoisted_17 = {
  class: "bottom-half",
  style: {"width":"100%","overflow":"auto"}
}
const _hoisted_18 = { class: "ls-table" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "text" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["colspan"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["colspan"]
const _hoisted_27 = { key: 2 }
const _hoisted_28 = ["colspan"]
const _hoisted_29 = { "data-label": "Practice name" }
const _hoisted_30 = { "data-label": "Practice ID" }
const _hoisted_31 = { "data-label": "Date of Investigation" }
const _hoisted_32 = { "data-label": "Investigation type" }
const _hoisted_33 = { "data-label": "Appointment status" }
const _hoisted_34 = {
  key: 0,
  class: "fal fa-info-circle pa-1"
}
const _hoisted_35 = { "data-label": "Reply required" }
const _hoisted_36 = { "data-label": "Status" }

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Search practice name or ID",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchKeyword]
            ]),
            _hoisted_7
          ]),
          _createElementVNode("label", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showActiveStatus) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.showActiveStatus]
            ]),
            _hoisted_9
          ]),
          _createElementVNode("label", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showCauseDrivenOnly) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.showCauseDrivenOnly]
            ]),
            _hoisted_11
          ]),
          _createElementVNode("label", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.isReplyRequired) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.isReplyRequired]
            ]),
            _hoisted_13
          ]),
          _createElementVNode("label", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.showTrainingStatus) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.showTrainingStatus]
            ]),
            _hoisted_15
          ])
        ])
      ])
    ]),
    _hoisted_16,
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("table", _hoisted_18, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", {
                class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(h.text), 1),
                  (h.sortable)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', _ctx.sortMethod])
                      }, _hoisted_22, 2))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_19))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_24)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_26)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.investigationsData.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, "No Records", 8, _hoisted_28)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.investigationsDisplay.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.investigationsDisplay, (i) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_29, _toDisplayString(i.latestPracticeLogData.branchId == null ? i.latestPracticeLogData.name :
                i.latestPracticeLogData.name + ' (' + i.latestPracticeLogData.tradingName + ')'), 1),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(i.latestPracticeLogData.branchId == null ? i.latestPracticeLogData.firmId
                : i.latestPracticeLogData.firmId + ' - ' + i.latestPracticeLogData.branchId), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.formatDate(i.commencementDate)), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(i.investigationTypeName), 1),
                        _createElementVNode("td", _hoisted_33, [
                          _createTextVNode(_toDisplayString(i.appointmentStatus) + " ", 1),
                          (i.appointments.length > 1)
                            ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_34, null, 512)), [
                                [_directive_tippy, {content: _ctx.appointmentsTippy(i.appointments)}]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_35, _toDisplayString(i.isReplyRequired ? 'Yes' : ''), 1),
                        _createElementVNode("td", _hoisted_36, _toDisplayString(i.statusName), 1)
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}